<template>
  <div>
    <gs-modal
      v-model="visible"
      :title="isEdit?name+'-用户组-报警':'新建'+'-用户组-报警'"
      :before-close="beforeClose"
      :before-confirm="beforeConfirm"
      :has-form="true"
      class="group-alarm"
      width="50%"
      top="10%"
      @cancel="close"
      @close="close"
      @confirm="handleConfirm"
    >
      <gs-tabs
        v-model="activeName"
        type="content-tab"
      >
        <gs-tab-pane
          label="报警用户组"
          name="userGroup"
          icon="star"
        >
          <div class="page-form">
            <gs-form
              label-width="95px"
              label-position="left"
              gap="small"
            >
              <div class="general">
                <div class="title">概述</div>
                <gs-form-item
                  label="名称"
                  prop="name"
                >
                  <gs-input
                    ref="nameInput"
                    v-model="name"
                  />
                </gs-form-item>
                <gs-form-item
                  label="描述"
                  prop="description"
                  class="form-item-description"
                >
                  <gs-input
                    v-model="description"
                    type="text"
                  />
                </gs-form-item>

                <gs-form-item
                  label="用户/用户组"
                  prop="userOrUserGroup"
                >
                  <gs-input
                    :disabled="showUserOrGroup === ''"
                    v-model="showUserOrGroup"
                    style="width:84%"
                  />
                  <gs-button @click="addUserOrGroup">...</gs-button>
                </gs-form-item>

                <gs-form-item
                  label="时间表"
                  prop="timeChart"
                  class="form-item-timeChart"
                >
                  <gs-input
                    v-model="showTimeChart"
                    :disabled="showTimeChart === ''"
                    style="width:84%"
                  />
                  <gs-button @click="addTimeChart">...</gs-button>
                </gs-form-item>

                <gs-form-item
                  label="状态"
                  prop="status"
                  class="form-item-timeChart"
                >
                  <gs-checkbox v-model="form.status" />
                </gs-form-item>
              </div>
            </gs-form>
          </div>
        </gs-tab-pane>
      </gs-tabs>
      <span slot="footer" class="dialog-footer">
        <gs-button type="primary" size="mini"  @click="handleConfirm">确 定</gs-button>
        <gs-button type="primary"  size="mini"  @click="beforeClose">取 消</gs-button>
        <gs-button type="primary"  size="mini">帮 助</gs-button>
    </span>
    </gs-modal>
    <gs-modal
      v-model="visibleUsers"
      :before-close="beforeCloseUsers"
      :has-form="true"
      class="user-select"
      title="添加用户/用户组"
      width="33%"
      @cancel="closeUsers"
      @confirm="handleConfirmUsers"
    >
      <div class="dataList">
        <gs-table
          ref="selectTable"
          :data="userAndGroupList"
          :height="260"
          style="width: 100%;margin-bottom: 12px"
          @select="getUserSelection"
          @select-all="getUserSelection"
        >
          <gs-table-column
            :show-overflow-tooltip="true"
            type="selection"
          />
          <gs-table-column
            :show-overflow-tooltip="true"
            prop="name"
            label="名称"
          />
          <gs-table-column
            :show-overflow-tooltip="true"
            prop="type"
            label="类型"
          />
        </gs-table>
      </div>
    </gs-modal>
    <gs-modal
      v-model="visibleTimeChart"
      :before-close="beforeCloseTimeChart"
      class="timeChart-select"
      title="添加时间表"
      @close="closeTimeChart"
      @confirm="handleConfirmTimeChart"
    >
      <div class="dataList">
        <gs-tree
          v-if="visibleTimeChart"
          ref="tree"
          :data="timeChartList"
          :props="props"
          :disable-node="true"
          :leaf-checkbox-only="true"
          :node-key="'id'"
          show-checkbox
          @check-change="checkEvent"
        />
      </div>
    </gs-modal>
  </div>
</template>
<script>
import { mapState, mapMutations } from 'vuex'
import service from '../../service/leftService.js'
import authorityService from '../../service/authorityService.js'
export default {
  data () {
    return {
      isEdit: false,
      activeName: 'userGroup',
      visibleUsers: false,
      userAndGroupList: [],
      userSelection: [],
      visibleTimeChart: false,
      timeChartList: [],
      props: {
        label: 'name',
        disabled: 'type:folder'
      },
      form: {
        userOrGroup: null,
        timeChart: null,
        status: true
      },
      name: '',
      description: '',
      showUserOrGroup: '',
      showTimeChart: ''
    }
  },
  computed: {
    ...mapState({
      nodeData: 'nodeTree',
      objectData: 'objectInfo',
      visible: 'groupAlarmShow'
    })
  },
  watch: {
    'form.userOrGroup': function () {
      this.showUserOrGroup = this.form.userOrGroup ? this.form.userOrGroup.fullName : ''
    },
    'form.timeChart': function () {
      this.showTimeChart = this.form.timeChart ? this.form.timeChart.fullName : ''
    },
    showUserOrGroup () {
      if (this.form.userOrGroup && this.showUserOrGroup !== this.form.userOrGroup.fullName) {
        this.form.userOrGroup = null
      }
    },
    showTimeChart () {
      if (this.form.timeChart && this.showTimeChart !== this.form.timeChart.fullName) {
        this.form.timeChart = null
      }
    },
    visible () {
      if (this.visible) {
        setTimeout(() => {
          this.$refs.nameInput.focus()
        }, 100)
        if (JSON.stringify(this.objectData) !== '{}' && this.objectData.type === 'userGroupAlarm') {
          this.form = this.objectData.attribute ? this.objectData.attribute : {}
          this.description = this.objectData.description ? this.objectData.description : ''
          this.name = this.objectData.name ? this.objectData.name : ''
          this.activeName = 'userGroup'
          this.isEdit = true
          if (this.form.userOrGroup !== null) {
            if (this.form.userOrGroup.type === 'user') {
              authorityService.getUserDetail(this.form.userOrGroup.id).then(res => {
                this.form.userOrGroup = res
                this.form.userOrGroup.name = res.username
                this.form.userOrGroup.type = 'user'
              })
            } else {
              authorityService.getGroupDetail(this.form.userOrGroup.id).then(res => {
                this.form.userOrGroup = res
                this.form.userOrGroup.name = res.groupName
                this.form.userOrGroup.type = 'userGroup'
              })
            }
          }
        } else {
          this.form = {
            userOrGroup: null,
            timeChart: null,
            status: true
          }
          this.description = ''
          this.name = ''
          this.activeName = 'userGroup'
          this.isEdit = false
        }
      }
    }
  },
  methods: {
    ...mapMutations({
      close: 'GROUP_ALARM_HIDE',
      showSelectDialog: 'SELECT_DIALOG_SHOW',
      needReload: 'NEED_RELOAD_TREE'
    }),
    handleConfirm () {
      // 用户和用户组只传id和type
      if (this.form.userOrGroup != null) {
        if (this.form.userOrGroup.type === 'user') {
          this.form.userOrGroup = {
            id: this.form.userOrGroup.userId,
            type: this.form.userOrGroup.type
          }
        } else {
          this.form.userOrGroup = {
            id: this.form.userOrGroup.groupId,
            type: this.form.userOrGroup.type
          }
        }
      }
      // 时间表只传id
      if (this.form.timeChart != null) {
        this.form.timeChart = this.form.timeChart.id
      }
      if (this.objectData.id != null && this.objectData.type === 'userGroupAlarm') {
        let param = {
          'id': this.objectData.id,
          'name': this.name,
          'type': this.objectData.type,
          'value': this.objectData.value,
          'parentId': this.objectData.parentId,
          'description': this.description,
          'attribute': this.form
        }
        service.renamePoint(param).then(res => {
          this.$Message.success('修改成功')
          this.close()
        }).catch(err => {
          console.log(err)
         // this.$Message.error(err.message)
        })
      } else {
        let param = {
          'name': this.name,
          'type': 'userGroupAlarm',
          'parentId': this.objectData.id,
          'description': this.description,
          'attribute': this.form
        }
        service.newAddPoint(param).then(res => {
          this.$Message.success('添加成功')
          this.close()
        }).catch(err => {
          this.$Message.error(err.message)
        })
      }
    },
    beforeConfirm (e, done) {
      if (this.name === null || this.name === '') {
        this.$Message.warning('名称不能为空!')
        return
      }
      // done(false)可以阻止modal关闭
      done()
    },
    beforeClose (e, done) {
      // done(false)可以阻止modal关闭
      this.close()
    },
    addUserOrGroup () {
      let _this = this
      this.visibleUsers = true
      this.userAndGroupList = []
      authorityService.getUserList().then(res => {
        res.forEach((value, index, array) => {
          value.name = value.username
          value.type = 'user'
        })
        this.userAndGroupList = this.userAndGroupList.concat(res)
        authorityService.getGroupList().then(res => {
          res.forEach((value, index, array) => {
            value.name = value.groupName
            value.type = 'userGroup'
          })
          this.userAndGroupList = this.userAndGroupList.concat(res)
          if (this.form.userOrGroup !== null) {
            setTimeout(() => {
              this.userAndGroupList.forEach(res => {
                if (res.userId !== undefined && this.form.userOrGroup.userId !== undefined && res.userId === this.form.userOrGroup.userId) {
                  _this.$refs.selectTable.toggleRowSelection(res, true)
                }
                if (res.groupId !== undefined && this.form.userOrGroup.groupId !== undefined && res.groupId === this.form.userOrGroup.groupId) {
                  _this.$refs.selectTable.toggleRowSelection(res, true)
                }
              })
            }, 0)
          }
        })
      })
    },
    beforeCloseUsers () {
      this.visibleUsers = false
    },
    closeUsers () {
      this.visibleUsers = false
    },
    getUserSelection (selection, row) {
      this.userSelection = selection
    },
    handleConfirmUsers () {
      if (this.userSelection.length > 1) {
        this.$Message.warning('最多只能选择一个')
        return
      }
      this.form.userOrGroup = this.userSelection[0]
      this.closeUsers()
    },
    addTimeChart () {
      this.timeChartList = []
      let _this = this
      this.visibleTimeChart = true
      service.getTree('TimeChart').then(res => {
        if (res[0] !== null) {
          this.timeChartList = res
        }
        if (this.form.timeChart !== null) {
          setTimeout(() => {
            _this.$refs.tree.setChecked(this.form.timeChart.id, true)
          }, 0)
        }
      })
    },
    beforeCloseTimeChart () {
      this.visibleTimeChart = false
    },
    closeTimeChart () {
      this.visibleTimeChart = false
    },
    checkEvent (node, isSelect, halfSelect) {
      // console.log(node)
      // console.log(isSelect)
      // console.log(halfSelect)
      // if (node.type !== 'timeChart') {
      //   console.log(node)
      //   this.$Message.error('此节点为目录，无法被选择')
      //   this.$refs.tree.setChecked(node.id, false)
      // }
    },
    handleConfirmTimeChart () {
      let array = this.$refs.tree.getCheckedNodes(true)
      if (array.length > 1) {
        this.$Message.warning('最多只能选择一个')
        return
      }
      if (array != null && array.length !== 0) {
        this.form.timeChart = array[0].data
      }
      this.closeTimeChart()
    }
  }
}
</script>
<style lang="scss" scoped>
  .group-alarm {
    .page-form {
      .title {
        color: #0073e8;
        margin-bottom: 12px;
      }
      .gs-form-item {
        margin-bottom: 12px;
      }
      .button {
        float: right;
      }
    }
  }
  .dataList {
    height: 300px;
      overflow: auto;
      margin-bottom: 12px;
      padding: 12px;
      border: solid 1px #d9d9d9;
      border-radius: 1px;
  }

</style>



// WEBPACK FOOTER //
// src/components/alarm/alarmGroup.vue